import { Svgs, svgOptions } from "../../types"
import Typography, { TypographyElement } from "../RedesignTypography"

import { Color } from "../components/typography"
import React from "react"
import SvgIcon from "../components/icon/svgIcons"
import { types } from "react-bricks/frontend"

export interface UspItemRedesignProps {
    icon: Svgs
    text: TypographyElement[]
}

const UspItemRedesign: types.Brick<UspItemRedesignProps> = ({ icon }) => {
    return (
        <li className="md:col-span-4 md:odd:-mt-20 md:even:-col-end-1 xl:col-span-3 xxl:col-span-5">
            <SvgIcon icon={icon} className="mb-7 h-20 w-20 sm:h-25 sm:w-25" />
            <Color>
                <Typography size="P1" allowList={["S5", "sup", "link"]} propName="text" />
            </Color>
        </li>
    )
}

UspItemRedesign.schema = {
    name: "UspItemRedesign",
    label: "USP Item Redesign",
    hideFromAddMenu: true,
    sideEditProps: [
        {
            name: "icon",
            label: "Icon",
            type: types.SideEditPropType.Select,
            selectOptions: {
                options: svgOptions,
                display: types.OptionsDisplay.Select,
            },
        },
    ],

    getDefaultProps: (): UspItemRedesignProps => ({
        icon: Svgs.usp_1,
        text: [
            {
                type: "h3",
                children: [{ text: "Lorem ipsum dolor sit amet", S5: true }],
            },
            {
                type: "paragraph",
                children: [
                    {
                        text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed euismod, nunc ut laoreet tincidunt, nunc nisl aliquam nunc, eget aliquam nisl nunc eu nunc.",
                    },
                ],
            },
        ],
    }),
}

export default UspItemRedesign
